import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Downtime } from '../../../../core/services/times/downtime';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitGameWindow } from '../../../dialogs/exit-game-window/exit-game-window';
import { Subscription } from 'rxjs';
import { RdGameService } from '../../../services/games/rd-game';
import { PlayersService } from '../../../services/players/players';
import { GameInfoService } from '../../../services/games/game-info';
import { ListQuest } from '../../../services/lists/list-quest';
import { DifficultyLevel } from '../../../services/levels/difficulty-level';
import { AllStatus } from '../../../../core/services/status/all-status';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-exit-game',
  imports: [MatTooltipModule, TranslatePipe],
  templateUrl: './exit-game.html',
  styleUrl: './exit-game.scss'
})
export class ExitGame implements OnInit, OnDestroy{
  
  downtime = inject(Downtime);
  readonly dialog = inject(MatDialog);
  uuid: string;
  activatedRoute = inject(ActivatedRoute);

  rdb = inject(RdGameService);
  players = inject(PlayersService);
  gameInfo = inject(GameInfoService);
  router = inject(Router);
  private destroy$: Subscription;
  private destroyEvent$: Subscription;
  
  listQuest = inject(ListQuest);
  difficulty = inject(DifficultyLevel);
  allStatus = inject(AllStatus);

  translate = inject(TranslateService);

  subGameInfo: Subscription;
  txtDialog: any;
  subscriptionCL: any;
  
  ngOnDestroy(): void {
    if(this.subGameInfo){
      this.subGameInfo.unsubscribe();
    }
    if(this.destroy$){
      this.destroy$.unsubscribe();
    }
    if(this.destroyEvent$){
      this.destroyEvent$.unsubscribe();
    }
    if(this.subscriptionCL){
      this.subscriptionCL.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.loadTranslateText();
    this.allStatus.uuId$.subscribe((uuid: string)=>{
      if(uuid){
        this.uuid = uuid;
      }
    })
    this.destroy$ = this.router.events.subscribe((e: any)=>{
      if (e instanceof NavigationEnd) {
        
        if(e.url.includes("/waiting/") || e.url.includes("/lobby/")){
          this.allRunProccess();
        }

        // coop-game
        if(e.url.includes("/coop-game/")){ 
          this.allRunProccess();
        }
        if(e.url.includes("/single-game/")){ 
          this.allRunProccess();
        }

      }
    });

    this.subscriptionCL = this.allStatus.changeLanguage$.subscribe((change: boolean)=>{
      if(change){
        this.allStatus.setChangeLanguage(false);
        this.loadTranslateText();
      }
    });
    
  }

  loadTranslateText(){
    this.translate.get(['spinner']).subscribe(translations => {
      this.txtDialog = translations['spinner'];
    });
  }

  private allRunProccess(){
    this.subGameInfo = this.rdb.value$.subscribe({
      next:(gameInfo:any)=>{        
        
      },
      error:(err)=>{
        console.error(`allRunProccess - error events, ${err}`);
      }
    });
  }

  exitGame(){
    this.downtime.refreshTimer();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    const dialogRef = this.dialog.open(ExitGameWindow, dialogConfig);
    dialogRef.afterClosed().subscribe(result=>{
      if(result){
        
        this.proccessExitGame();
      }
    });
  }

  proccessExitGame(){
    if(this.router.url.includes("/waiting/") || this.router.url.includes("/lobby/")){
      this.allProccessExit();
      
    }

    if(this.router.url.includes("/single-game/")){ 
      this.proccessGame();
      this.allProccessExit();
      this.proccessTransitionOnPage();
    } 
        
    if(this.router.url.includes("/coop-game/")){ 
      this.proccessGame();
      this.allProccessExit();
      this.proccessTransitionOnPage();
    } 
  }

  private allProccessExit(){
    if(this.players.player.is_starter){
      this.allStatus.textSpinner = this.txtDialog?.txtExitGame; //txtCanceling;
    }else{
      this.allStatus.textSpinner = this.txtDialog?.txtExitGame; //txtCancelKoop;
    }
    this.allStatus.setDisplayProgressSpinner(true); 

    this.listQuest.clearStorage();
    this.difficulty.clear();
    this.allStatus.clearNowCard();
    this.allStatus.clearExplanationTxt();
    this.allStatus.setChangeUuId('');
    this.allStatus.setOpenFooter(false);
    if(this.players.player.is_starter){
      this.players.processDeletePlayersAndClosed(this.uuid, this.getAllPlayersId());
      this.players.detelePlayerStarter(this.uuid);
      //this.gameInfo.closedGame(this.uuid); 
    }else{
      this.players.detelePlayer(this.uuid);
      setTimeout(()=>{
        this.proccessListGame();
      },550);
    }
    
  }
  getAllPlayersId(): number[] {
    let playersList = this.rdb.game$?.players || [];
    let listId: Array<number> = [];
    playersList.forEach((item: any)=>{
      listId.unshift(item.player_id);
    });
    return listId;
  }

  private proccessGame(){

    if(this.gameInfo.gameInfo.turning_player_id === this.players.player.player_id && !this.players.player.is_starter){
      if(this.gameInfo.gameInfo?.card_now){
        this.rdb.deleteCard();
      }
      this.rdb.nextTurn();
    }

    if(this.players.player.is_starter){
      
      this.gameInfo.finishGame(this.uuid);
    }

  }

  private proccessTransitionOnPage(){
    this.router.navigate(['/step-one']);
  }

  private proccessListGame(){
    window.location.assign('/games');
    //this.router.navigate(['/games']);
  }

}
